import React from 'react';
import PropTypes from 'prop-types';
import { translationPropType } from '@eb/i18n';

import FormSubmitButton from '../FormSubmitButton';
import EmailField from '../EmailField';

import { formValidate } from '@eb/eds-utils';

import { newSignupValidate as validate } from '../utils';

import { SIGN_UP_FORM } from '../../constants';

class SignupEmailForm extends React.Component {
    static propTypes = {
        handleEmailEdit: PropTypes.func,

        handleSubmit: PropTypes.func.isRequired,
        buttonCTA: translationPropType,
        email: PropTypes.string,
        locale: PropTypes.string,
        recaptcha2PublicKey: PropTypes.string,
        showCaptcha: PropTypes.bool,
        fp: PropTypes.bool,
        showNotification: PropTypes.func,
        clearNotification: PropTypes.func,
        socialSSOSettings: PropTypes.shape({
            facebook: PropTypes.object,
        }),

        /* Props Provided Via ReduxForm */
        submitFailed: PropTypes.bool,
        submitting: PropTypes.bool,
    };

    UNSAFE_componentWillReceiveProps({ submitting, submitFailed, error }) {
        const { showNotification, clearNotification } = this.props;

        /*If the form has an error and submit failed, attempt
        to display a notification*/
        if (submitFailed && error) {
            showNotification(error);
        }

        /*We want to limit only one error notification to
        appear per form submission if the user has dismissed it.
        So each time submitting is true, then reset the flag.*/
        if (submitting) {
            clearNotification();
        }
    }

    componentWillUnmount() {
        const { clearNotification } = this.props;

        clearNotification();
    }

    render() {
        const {
            formErrors,
            handleSubmit,
            buttonCTA,
            submitting,
            submitFailed,
        } = this.props;

        const submitDisabled = submitting;

        return (
            <form
                onSubmit={handleSubmit}
                noValidate="novalidate"
                className="eds-fx--fade-in eds-fx--delay-2"
            >
                <EmailField
                    submitFailed={submitFailed}
                    formErrors={formErrors}
                    autoFocus={true}
                />
                <FormSubmitButton
                    submitDisabled={submitDisabled}
                    buttonClasses="eds-fx--fade-in-down eds-fx--delay-1 eds-l-mar-top-8"
                    buttonCTA={buttonCTA}
                />
            </form>
        );
    }
}

export default formValidate({
    validate,
    form: SIGN_UP_FORM,
    touchOnBlur: true,
})(SignupEmailForm);
